<div class="pb-8 pl-3 flex justify-between items-center">
  <div class="flex items-center">
    <mat-icon
      (click)="back()"
      class="cursor-pointer mr-3"
      aria-label="Panel arrow back icon"
      >arrow_back
    </mat-icon>
    <h2
      [innerHTML]="title | translate | nl2br"
      class="text-3xl"
      [ngClass]="subtitle ? 'secondary-label' : 'primary-label'"
    ></h2>
    <span class="flex items-center" *ngIf="subtitle">
      <mat-icon class="mx-4" aria-label="Panel subtitle navigation icon"
        >chevron_right
      </mat-icon>
      <h2
        [innerHTML]="subtitle | translate | nl2br"
        class="text-3xl primary-label"
      ></h2>
    </span>
  </div>
  <div
    *ngIf="enableCustomization"
    class="ternary-label mr-3 cursor-pointer items-center flex"
    tabindex="0"
    (click)="customize()"
    (keyup)="customize()"
    (keydown)="customize()"
    (focus)="customize()"
  >
    <mat-icon class="mr-2" aria-label="Tune icon">tune</mat-icon>
    {{ 'site.sitePanel.general.customize' | translate }}
  </div>
  <ng-content></ng-content>
</div>
